<template>
  <div class="row" v-if="canRead">
    <div class="col-md-12">
      <card style="padding: 10px;">
        <button type="button" v-if="canEdit" @click="addCompany" class="btn btn-fill btn-info" style="float: right; margin-top: -4px;">
          Add Company
        </button>
        <tabs ref="companiesTabs" value="Companies" tab-content-classes="text-center">
          <tab-pane title="Companies" key="companies" id="companies">
            <companies></companies>
          </tab-pane>
          <tab-pane title="Contacts" key="contacts" id="contacts">
            <contacts></contacts>
          </tab-pane>
        </tabs>
      </card>
    </div>
  </div>
</template>
<script>
import Permissions from 'src/utilities/permissions'
import {Tabs, TabPane, Card} from 'src/components/UIComponents'
import Companies from './Companies'
import Contacts from './Contacts'

export default {
  components: {
    Card,
    Companies,
    Contacts,
    Tabs,
    TabPane
  },
  computed: {
    canRead() {
      return this.$can('read', Permissions.COMPANIES)
    },
    canEdit() {
      return this.$can('edit', Permissions.COMPANIES)
    }
  },
  methods: {
    addCompany() {
      this.$store.commit('companies/resetEdit')
      this.$eventHub.$emit('show-modal-2', 'Company', '1000px')
    }
  }
}
</script>
<style scoped>

</style>
